import { createBrowserHistory } from 'history';
import { sendEventToSegment } from 'redux/modules/analytics';
import { PAGE_VIEW } from 'redux/modules/analytics/events';

const history = createBrowserHistory();

history.listen((location, action) => {
  if (action === 'PUSH' && location) {
    const { pathname: path } = location || {};
    sendEventToSegment(PAGE_VIEW, { path });
  }
});

export default history;
